interface CardItem {
  image: string;
  alt: string;
  tag: string;
  title: string;
  summary: string;
  time: string;
}

const cards: CardItem[] = [
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20illustration%2C%20celebrity%20dating%20rumor%20theme%2C%20warm%20peach%20coral%20tones%2C%20mysterious%20atmosphere%20with%20silhouettes%2C%20modern%20flat%20design%2C%20clean%20cream%20background%2C%20editorial%20photography%20style%20with%20soft%20lighting&width=600&height=400&seq=card-melon-01&orientation=landscape',
    alt: '顶流男星恋情曝光',
    tag: '娱乐爆料',
    title: '顶流男星深夜约会新晋小花，知情人士称已交往三月',
    summary: '网友拍到两人在某高档餐厅共进晚餐后一同乘车离开，细节令人浮想联翩。业内人士透露双方团队正在商讨公开策略。',
    time: '2 小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20set%20illustration%2C%20dramatic%20conflict%20scene%2C%20warm%20orange%20peach%20gradient%20tones%2C%20abstract%20people%20figures%2C%20modern%20flat%20design%2C%20clean%20cream%20background%2C%20editorial%20style%2C%20soft%20minimal&width=600&height=400&seq=card-melon-02&orientation=landscape',
    alt: '综艺录制现场冲突',
    tag: '网友爆料',
    title: '某热门综艺录制中断，两位常驻嘉宾当众翻脸',
    summary: '据现场观众爆料，游戏环节中两位嘉宾因规则分歧发生激烈争执，导演组紧急叫停录制进行调解，后续能否正常播出成谜。',
    time: '4 小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20internet%20influencer%20scandal%20illustration%2C%20tax%20investigation%20theme%2C%20warm%20coral%20peach%20tones%2C%20abstract%20money%20and%20warning%20elements%2C%20modern%20flat%20design%2C%20clean%20cream%20background%2C%20editorial%20style%2C%20soft%20lighting&width=600&height=400&seq=card-melon-03&orientation=landscape',
    alt: '网红偷税漏税',
    tag: '最新爆料',
    title: '千万粉丝网红涉嫌偷税被查，金额或创行业纪录',
    summary: '税务部门已正式约谈该网红及其团队，相关账号暂停更新。据知情人士透露，涉案金额可能高达数千万元，代言品牌紧急切割。',
    time: '6 小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20film%20set%20accident%20illustration%2C%20movie%20production%20theme%2C%20warm%20orange%20peach%20gradient%20tones%2C%20abstract%20camera%20and%20warning%20elements%2C%20modern%20flat%20design%2C%20clean%20cream%20background%2C%20editorial%20composition&width=600&height=400&seq=card-melon-04&orientation=landscape',
    alt: '电影拍摄事故',
    tag: '社会猛料',
    title: '大制作电影拍摄现场发生意外，替身演员重伤入院',
    summary: '剧组在拍摄高危动作戏时安全措施不当，导致替身演员从高处坠落。目前伤者仍在抢救中，制片方尚未就赔偿方案做出回应。',
    time: '8 小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20divorce%20illustration%2C%20broken%20relationship%20theme%2C%20warm%20coral%20peach%20gradient%20tones%2C%20abstract%20split%20silhouettes%2C%20modern%20flat%20design%2C%20clean%20cream%20background%2C%20editorial%20style%2C%20emotional%20but%20minimal&width=600&height=400&seq=card-melon-05&orientation=landscape',
    alt: '明星夫妻分居',
    tag: '娱乐爆料',
    title: '模范夫妻人设崩塌？知名明星夫妇被曝已分居半年',
    summary: '多位知情人士证实两人早已貌合神离，目前正在进行财产分割和抚养权谈判。双方经纪公司对传闻表示"不予置评"。',
    time: '10 小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20gaming%20streamer%20scandal%20illustration%2C%20cheating%20software%20theme%2C%20warm%20orange%20peach%20gradient%20tones%2C%20abstract%20gaming%20elements%2C%20modern%20flat%20design%2C%20clean%20cream%20background%2C%20editorial%20style%2C%20soft%20lighting&width=600&height=400&seq=card-melon-06&orientation=landscape',
    alt: '游戏主播外挂丑闻',
    tag: '网友爆料',
    title: '知名游戏主播私下贩卖外挂，聊天记录遭粉丝曝光',
    summary: '多张聊天截图显示该主播向 VIP 粉丝群兜售定制外挂程序，并指导安装使用。电竞协会已发声明谴责，平台方暂停其直播权限。',
    time: '12 小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20restaurant%20hygiene%20scandal%20illustration%2C%20food%20safety%20theme%2C%20warm%20coral%20peach%20gradient%20tones%2C%20abstract%20warning%20elements%2C%20modern%20flat%20design%2C%20clean%20cream%20background%2C%20editorial%20style%2C%20soft%20minimalist&width=600&height=400&seq=card-melon-07&orientation=landscape',
    alt: '网红餐厅卫生问题',
    tag: '最新爆料',
    title: '网红连锁餐厅后厨卫生触目惊心，过期食材屡禁不止',
    summary: '内部员工匿名曝光某网红连锁餐厅后厨真实状况：使用过期食材、篡改保质期标签、消毒流程形同虚设。市场监管部门已启动全面调查。',
    time: '14 小时前',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            图文爆料
          </h2>
          <p className="text-sm text-foreground-500">
            精选每日最新图文爆料，有图有真相，吃瓜更过瘾
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 6).map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden group cursor-pointer hover:border-accent-300/60 transition-colors"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-500/90 text-background-50 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 mb-2 line-clamp-2">
                  <strong>{item.title}</strong>
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {item.summary}
                </p>
                <span className="text-xs text-foreground-400">{item.time}</span>
              </div>
            </div>
          ))}
          <div className="sm:col-span-2 lg:col-span-3">
            <div
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden group cursor-pointer hover:border-accent-300/60 transition-colors flex flex-col lg:flex-row"
            >
              <div className="relative w-full lg:w-80 flex-shrink-0 aspect-[16/9] lg:aspect-auto overflow-hidden bg-background-100">
                <img
                  src={cards[6].image}
                  alt={cards[6].alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-500/90 text-background-50 font-medium whitespace-nowrap">
                    {cards[6].tag}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col justify-center">
                <h3 className="text-sm font-semibold text-foreground-800 mb-2">
                  <strong>{cards[6].title}</strong>
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                  {cards[6].summary}
                </p>
                <span className="text-xs text-foreground-400">{cards[6].time}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}